module.exports = __webpack_public_path__ + "static/media/400056_02.dfd173d3.png";